import { cloneDeep, isNull, isUndefined } from 'lodash';
import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { getLayerCenterPoint } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { ILayerProps, IMarkupLayerProps, IPoint } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const WidthFeature: React.FC<{
    id?: string;
    width?: number;
    maxValue?: number;
    minValue?: number;
    onAfterChange?: Function;
    onChange?: Function;
    style?: React.CSSProperties;
    trackCode?: string | number;
}> = React.memo(({ style, width, id, maxValue = 100, minValue = 0, onAfterChange, onChange, trackCode }) => {
    const { $t } = useLocaleStore();
    const oldLayer = useRef<ILayerProps | null>(null);
    const centerPoint = useRef<IPoint | null>(null);

    const needListener = !isUndefined(id);
    const res = useListenActivePickLayerProps(
        editor,
        (layer) => {
            if (!layer) return null;
            const { fill } = layer.data as IMarkupLayerProps;
            return {
                width: fill.width,
            };
        },
        true,
        needListener,
    );

    if (needListener) {
        if (isNull(res)) {
            return null;
        }
        width = res.width;
    } else {
        if (isUndefined(width)) return null;
    }

    return (
        <div className="c-markup-panel__item c-markup-panel__item-width" style={{ ...style }}>
            <LabelAction title={$t((v) => v.panel.markupPanel.thickness)} align={true}>
                <div style={{ width: 174 }}>
                    <SliderInput
                        value={width}
                        max={maxValue}
                        min={minValue}
                        showStepBtn={true}
                        type="horizontal"
                        onChange={(val: number) => {
                            if (id) {
                                if (oldLayer.current === null) {
                                    const layer = editor.services.flatLayer.getLayer(id, true);
                                    oldLayer.current = cloneDeep(layer);
                                    centerPoint.current = getLayerCenterPoint(layer);
                                    editor.markupLayer.setAttrOperateOriginData(layer);
                                }
                                editor.markupLayer.setFillWidth(id, val);
                            }
                            onChange?.(val);
                        }}
                        onAfterChange={(val: number) => {
                            if (id) {
                                if (oldLayer.current) {
                                    editor.markupLayer.setFillWidth(id, val, oldLayer.current);
                                }
                                oldLayer.current = null;
                                editor.markupLayer.clearAttrOperateOriginData();
                            }
                            onAfterChange?.(trackCode, val);
                        }}
                    />
                </div>
            </LabelAction>
        </div>
    );
});
